import React from 'react';
import { useTranslation } from 'react-i18next';

import { useMaintenanceModeData } from './useMaintenanceModeData';
import { simpleDateFormatter } from '../../../helpers/dateFormatter';

import { MaintenanceModePageWrapper } from './style';

/**
 * Komponent zawierający w sobie dane o przerwie technicznej, który jest wywoływany w momencie otrzymania informacji z panelu admina
 *
 */
const MaintenanceModePage = (): JSX.Element => {
  const { t } = useTranslation();
  const maintenanceMode = useMaintenanceModeData();

  return (
    <MaintenanceModePageWrapper>
      {maintenanceMode ? (
        <React.Fragment>
          <section className='header'>
            <img src={require('../../../images/logo_full_color.svg')} alt='logo' />
          </section>
          <section className='content'>
            <h1>{maintenanceMode.title}</h1>
            <h2>{maintenanceMode.message}</h2>
            <h3>{t('MAINTENANCE_MODE_END_DATE')}:</h3>
            <h3 className='withBold withPaddingBottom'>{simpleDateFormatter(maintenanceMode.endDate)}</h3>
            <h3>{t('MAINTENANCE_MODE_PAGE_BOK_INFO')}</h3>
            <img src={require('../../../images/UCI_logo_color.png')} alt='logo_UCI' />
            <h4 className='withBold'>{t('MAINTENANCE_MODE_PAGE_BOK_TITLE')}</h4>
            {t('MAINTENANCE_MODE_PAGE_BOK_CONTACT')}
            <h5>{t('MAINTENANCE_MODE_PAGE_BOK_CONTACT_NET')}</h5>
            <h4>{t('MAINTENANCE_MODE_PAGE_BOK_EMAIL')}</h4>
          </section>
        </React.Fragment>
      ) : null}
    </MaintenanceModePageWrapper>
  );
};

export default MaintenanceModePage;
